<template>
  <div class="item-component s-item-four">
    <div class="s-item-title">
      <h4 class="chart-title">
        <i class="el-icon-s-grid"></i>
        新生男女比例
      </h4>
    </div>

    <chart-four
      style="height: 90%"
      :value="chartData"
      :subtext="subtext"
    ></chart-four>
  </div>
</template>

<script>
import ChartFour from "../charts/chart04";
import { chartData04 } from "@/assets/json/chartData";
import { mapState } from "vuex";
export default {
  components: {
    ChartFour,
  },
  data() {
    return {
      chartData: [],
      subtext: "",
      enrollmentYear: "", // 入学年份
    };
  },
  computed: {
    ...mapState("dic", ["_CURRENTYEAR", "SUCCESS_CODE","_CURRENT_ACADEMIC"]),
  },
  created() {
    this.enrollmentYear = this._CURRENTYEAR[0].value;
    this.getStudentSexNum();
  },
  mounted() {},
  methods: {
    // 获取新生男女人数
    getStudentSexNum() {
      let params = { enrollmentYear: this.enrollmentYear, academicDegree: this._CURRENT_ACADEMIC };
      this.$http
        .get("/welcome-forecast/statistics/getStudentSexNum", { params })
        .then((res) => {
          if (res.code == this.SUCCESS_CODE) {
            // console.log(res);
            let data = res.data;
            this.chartData = [
              { value: data.maleNum, name: "男生" },
              { value: data.femaleNum, name: "女生" },
            ];
            let percent = "";
            if (data.femaleNum && data.maleNum) {
              this.subtext = `1:${(data.femaleNum / data.maleNum).toFixed(2)}`;
            } else {
              this.subtext = `${data.maleNum}:${data.femaleNum}`;
            }
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
  },
};
</script>
